import { CurrencyAmount, CurrencyCode, CurrencyCodes } from '../../models/payroll-currency.model';
import { isPlanfixDealPayroll } from '../../models/deal-payroll.model';
import {
  EMPTY_TEXT,
  FIRST_INDEX,
  SCHEDULE_PERIOD_SEPARATOR,
  SCHEDULE_REST_SEPARATOR,
  SCHEDULE_TITLE_END_PREFIX,
  SCHEDULE_TITLE_FALLBACK,
  SCHEDULE_TITLE_PERIOD_PREFIX,
  SCHEDULE_TITLE_START_PREFIX,
  SCHEDULE_WORK_PREFIX
} from './my-working-report.constants';
import { MyWorkingReportPayrollPresentation } from './my-working-report-payroll.presentation';
import { ReportViewModel, RowVisibility, WorkScheduleViewModel } from './my-working-report.types';

export function normalizeWorkingReports(
  reports: ReportViewModel[],
  rowNames: RowVisibility[],
  payrollPresentation: MyWorkingReportPayrollPresentation
): ReportViewModel[] {
  reports.forEach((report: ReportViewModel) => {
    normalizeSummary(report);
    payrollPresentation.mapInitialReport(report);
    rowNames.push({name: report.summaryRecord.username, show: true});
    report.records.forEach(record => {
      record.salarySupplements = Number(record.salarySupplements);
      record.wageRate = Number(record.wageRate);
    });
  });
  return reports;
}

export function sortWorkingReports(reports: ReportViewModel[]): void {
  reports.sort((first: ReportViewModel, second: ReportViewModel) => {
    const firstName = first.lastName || EMPTY_TEXT;
    const secondName = second.lastName || EMPTY_TEXT;
    return firstName.localeCompare(secondName);
  });
}

export function workingReportCurrency(reports: ReportViewModel[]): CurrencyCode {
  return reports.length ? reports[FIRST_INDEX].summaryRecord.displayCurrency : CurrencyCodes.BYN;
}

export function trackCurrencyAmount(index: number, amount: CurrencyAmount): CurrencyCode {
  return amount.currency;
}

export function workScheduleTitle(schedule: WorkScheduleViewModel): string {
  const start = schedule.workStart || SCHEDULE_TITLE_FALLBACK;
  const end = schedule.workEnd || SCHEDULE_TITLE_FALLBACK;
  const segments = schedule.segments.map(segment =>
    SCHEDULE_WORK_PREFIX + segment.workDays + SCHEDULE_REST_SEPARATOR + segment.restDays
  ).join(SCHEDULE_PERIOD_SEPARATOR);
  return SCHEDULE_TITLE_START_PREFIX + start + SCHEDULE_TITLE_END_PREFIX + end
    + SCHEDULE_TITLE_PERIOD_PREFIX + segments;
}

function normalizeSummary(report: ReportViewModel): void {
  if (isPlanfixDealPayroll(report)) {
    return;
  }
  report.summaryRecord.salarySupplements = Number(report.summaryRecord.salarySupplements);
  report.summaryRecord.wageRate = Number(report.summaryRecord.wageRate);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-collection.ts